<script>
import BaseFilter from '@/modules/_global/_components/filters/BaseAutocompleteSearchRequestFilter.vue';
import { DevicesService } from '@/services/devices.service';

export default {
  name: 'DeviceCodesFilter',

  extends: BaseFilter,

  data() {
    return {
      name: 'device_code'
    };
  },

  methods: {
    getData() {
      return DevicesService.getFilteredDeviceCodes({ search: this.search })
        .then(({ data }) => {
          return data.data;
        })
        .catch(console.error);
    }
  }
};
</script>
